import React from 'react';
import classnames from 'classnames';
import { Row, Col, Button, Nav, NavItem, NavLink, Tooltip,
  TabContent, TabPane,
  Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { FaCog } from 'react-icons/fa';
import EMRelationGraph from '../Charts/EMRelationGraph.jsx'
import SettingsDialogComparison from '../Dialogs/SettingsDialogComparison';
import SankeyDiagram from '../Charts/SankeyDiagram.jsx';

class MapsAnalysisDialog extends React.Component {
  constructor(props) {
    super();
    this.state = {
      activeView: 'list',
      showSettingsDialog: false,
      settings: {
        teamCount: 10,
        organismCount: 10,
        publicationCount: 10,
      }
    };
  }

  toggleView = (tab => {
    if (this.state.activeView !== tab) {
      this.setState({
        activeView: tab
      });
    }
  }).bind(this)

  buildEMRelationGraph(maps) {
    let {
      listOrganism,
      listAuthorFull,
      listTeam,
      listPapers,
      dataListEMDs,
    } = this.props.base;
    let papers = [], organisms = [], authors = [],
      linksEP = [], linksPO = [], linksPA = [];
    let unknownOrgan = listOrganism.findIndex(o => o.id === '(null)');
    maps.forEach((m, midx) => {
      let paperId = dataListEMDs[m].d, teamList = dataListEMDs[m].u;
      let organismList = dataListEMDs[m].o;
      papers.push(paperId);
      organisms = organisms.concat(organismList);
      authors = authors.concat(teamList);
      linksEP.push([midx, paperId]);
      linksPO = linksPO.concat(organismList.map(o => [paperId, o])
        .filter(link => link[1] !== unknownOrgan));
      linksPA = linksPA.concat(teamList.map(u => [paperId, u]));
    });
    papers = papers.filter((p, index) => papers.indexOf(p) === index);
    organisms = organisms.filter((o, index) => organisms.indexOf(o) === index && o !== unknownOrgan);
    authors = authors.filter((a, index) => authors.indexOf(a) === index);
    linksEP.forEach(link => {
      link[1] = papers.indexOf(link[1]);
    })
    linksPO.forEach(link => {
      link[0] = papers.indexOf(link[0]);
      link[1] = organisms.indexOf(link[1]);
    })
    linksPA.forEach(link => {
      link[0] = papers.indexOf(link[0]);
      link[1] = authors.indexOf(link[1]);
    })
    papers = papers.map(p => ({
      name: listPapers[p] ? listPapers[p].title : '(unknown)',
      value: listPapers[p] ? listPapers[p].count : 0,
      id: p,
    }));
    organisms = organisms.map(o => ({
      name: listOrganism[o].name,
      value: listOrganism[o].count,
      id: o,
    }));
    authors = authors.map(a => ({
      name: listAuthorFull[listTeam[a].team[0]].name,
      value: listAuthorFull[listTeam[a].team[0]].count,
      id: listTeam[a].team[0],
    }));
    let emds = maps.map(m => ({
      name: dataListEMDs[m].n,
      value: 1,
      id: m,
    }));

    return (<EMRelationGraph
      emds={emds}
      papers={papers}
      organisms={organisms}
      authors={authors}
      linksEP={linksEP}
      linksPO={linksPO}
      linksPA={linksPA}
      onDrill={this.props.onDrill}
    />);
  }

  buildComparisonGraph(props, settings) {
    if(!props.base)
      return;
    let {
      listOrganism,
      listAuthorFull,
      listTeam,
      listPaper,
      listPublication,
      dataListEMDs,
    } = props.base;
    let filterOrganisms =
      listOrganism.map((o, index) => ({name: o.name, id: index, ncbi: o.id, value: 0}));
    let filterTeams =
      listTeam.map((t, index) => ({id: index, value: 0, ...t}));
    let filterPublications =
      listPublication.map((p, index) => ({name: p.name, id: index, value: 0}));
    props.maps.forEach(i => {
      dataListEMDs[i].o.map(o => {
        if(filterOrganisms[o])
          filterOrganisms[o].value++;
      })
      dataListEMDs[i].u.map(u => {
        if(filterTeams[u])
          filterTeams[u].value++;
      })
      if(filterPublications[dataListEMDs[i].p])
        filterPublications[dataListEMDs[i].p].value++;
    });
    filterOrganisms = filterOrganisms.filter(c => c.value>0);
    filterOrganisms.sort((a,b) => b.value-a.value);
    filterTeams = filterTeams.filter(c => c.value>0);
    filterTeams.sort((a,b) => b.value-a.value);
    filterPublications = filterPublications.filter(c => c.value>0);
    filterPublications.sort((a,b) => b.value-a.value);

    let {teamCount, organismCount, publicationCount} = settings;
    let nodeDataTeam = filterTeams.slice(0, teamCount).map(t => ({name: listAuthorFull[t.team[0]].name, index: t.team[0]}));
    let nodeDataOrganism = filterOrganisms.slice(0, organismCount).map(o => ({name: o.name, index: o.id}));
    let nodeDataPublication = filterPublications.slice(0, publicationCount).map(o => ({name: o.name, index: o.id}));
    teamCount = nodeDataTeam.length;
    organismCount = nodeDataOrganism.length;
    publicationCount = nodeDataPublication.length;
    let linkCountP2T = teamCount * (publicationCount+1);
    let linkCountT2O = teamCount * (organismCount+1);
    let linkWeights = Array.from({length: linkCountP2T + linkCountT2O}, () => 0);
    dataListEMDs.forEach(d => d.f.forEach(f => {
      let fidx = nodeDataTeam.findIndex(t => t.index === f);
      let pidx = nodeDataPublication.findIndex(t => t.index === d.p);
      if(fidx < 0) return;
      if(pidx < 0) pidx = publicationCount;
      ++linkWeights[teamCount * pidx + fidx];
    }))
    dataListEMDs.forEach(d => d.f.forEach(f => d.o.forEach(o => {
      let fidx = nodeDataTeam.findIndex(t => t.index === f);
      let oidx = nodeDataOrganism.findIndex(t => t.index === o);
      if(fidx < 0) return;
      if(oidx < 0) oidx = organismCount;
      ++linkWeights[linkCountP2T + teamCount * oidx + fidx];
    })))
    nodeDataPublication.push({name: 'Other publications'});
    nodeDataOrganism.push({name: 'Other organisms'});
    this.nodeData = nodeDataPublication.concat(nodeDataTeam).concat(nodeDataOrganism);
    this.linkData = linkWeights.map((w, index) => (index < linkCountP2T ? {
      source: nodeDataTeam[index % teamCount].name,
      target: nodeDataPublication[Math.floor(index / teamCount)].name,
      value: w,
    } : {
      source: nodeDataOrganism[Math.floor((index - linkCountP2T) / teamCount)].name,
      target: nodeDataTeam[(index - linkCountP2T) % teamCount].name,
      value: w,
    })).filter(l => l.value)
    return (
      <div>
        <Row>
          <Col>
            <SankeyDiagram
              width={1100}
              height={900}
              data={this.nodeData}
              links={this.linkData}
            />
          </Col>
        </Row>
        <Button
          className="settings"
          style={{ position: 'absolute', top: '30px', right: '15px' }}
          onClick={this.toggleSettingsDialog}
        ><FaCog /></Button>
        <SettingsDialogComparison
          isOpen={this.state.showSettingsDialog}
          toggle={this.toggleSettingsDialog}
          settings={this.state.settings}
          onApply={this.applySettings}
        />
      </div>
    )
  }

  renderViewToggle() {
    return (
      <Nav tabs>
        <NavItem>
          <NavLink
            id='item-list'
            className={classnames({ active: this.state.activeView === 'list', handcursor: true })}
            onClick={() => { this.toggleView('list'); }}
          >
            List
          </NavLink>
        </NavItem>
        <Tooltip
          placement="bottom"
          isOpen={this.state.showTooltipList}
          target="item-list"
          toggle={(() => this.setState({showTooltipList: !this.state.showTooltipList})).bind(this)}
        >List all maps</Tooltip>
        <NavItem>
          <NavLink
            id='item-cluster'
            className={classnames({ active: this.state.activeView === 'cluster', handcursor: true })}
            onClick={() => { this.toggleView('cluster'); }}
          >
            Cluster
          </NavLink>
        </NavItem>
        <Tooltip
          placement="bottom"
          isOpen={this.state.showTooltipCluster}
          target="item-cluster"
          toggle={(() => this.setState({showTooltipCluster: !this.state.showTooltipCluster})).bind(this)}
        >Analyze entries relation by clustering</Tooltip>
        <NavItem>
          <NavLink
            id='item-compare'
            className={classnames({ active: this.state.activeView === 'compare', handcursor: true })}
            onClick={() => { this.toggleView('compare'); }}
          >
            Comparison
          </NavLink>
        </NavItem>
        <Tooltip
          placement="bottom"
          isOpen={this.state.showTooltipComparison}
          target="item-compare"
          toggle={(() => this.setState({showTooltipComparison: !this.state.showTooltipComparison})).bind(this)}
        >Compare entries</Tooltip>
      </Nav>
    )
  }

  render() {
    let {
      dataListEMDs,
    } = this.props.base;
    return (
      <Modal isOpen={true} toggle={this.props.toggle}
        style={this.state.activeView !== 'list' ? { 'max-width': '1200px', margin: 'auto' } : {}}
      >
        <ModalBody>
          {this.renderViewToggle()}
          <TabContent activeTab={this.state.activeView}>
            <TabPane tabId="list">
              {this.props.maps.map(d => (
                <Button
                  className='emdbadge'
                  size='sm'
                  onClick={() => this.props.onEMDSelected(d)}
                >
                  {dataListEMDs[d].n.slice(4, 10)}
                </Button>
              ))}
            </TabPane>
            <TabPane tabId="cluster">
              {this.state.activeView === 'cluster' &&
              this.buildEMRelationGraph(this.props.maps)}
            </TabPane>
            <TabPane tabId="compare">
              {this.state.activeView === 'compare' &&
              this.buildComparisonGraph(this.props, this.state.settings)}
            </TabPane>
          </TabContent>
        </ModalBody>
      </Modal>
    )
  }
}

export default MapsAnalysisDialog;
